export class OntopRepositoryError extends Error {
}
